// eslint-disable-next-line import/no-extraneous-dependencies
import Mustache from 'mustache'
import english from 'shared/src/resource/translation/en.json'

import type { LanguageCode } from 'shared/src/util/language'
import { getLanguageConfig, getDeviceBrandName, getHardwareName } from 'shared/src/util/language'
import { isValue } from 'shared/src/util/typeGuard'

const translationCache: Partial<Record<LanguageCode, Record<string, string>>> = {
  en: english, // Keep English preloaded
}

export const loadLanguage = async (lang: LanguageCode) => {
  try {
    const translation = await import(`shared/src/resource/translation/${lang}.json`)
    translationCache[lang] = translation.default
    return translation.default
  } catch (error) {
    console.error(`Failed to load translation for ${lang}`, error)
    return {}
  }
}

const { langCode } = getLanguageConfig()

export type MustacheOptions = {
  deviceBrandName: string
  hardwareName: string
}

export const createTranslations =
  (mustacheOptions: MustacheOptions) =>
  (key: string): string => {
    try {
      const language = translationCache[langCode]
      if (!isValue(language)) {
        loadLanguage(langCode).then((res: Record<string, string>) => {
          return renderMustache(res, key, mustacheOptions)
        })
      } else {
        return renderMustache(language, key, mustacheOptions)
      }
      return key
    } catch (error) {
      console.error(`Translation error for '${key}'`, JSON.stringify(error))
      return key
    }
  }

const renderMustache = (
  translations: Record<string, string> | undefined,
  key: string,
  mustacheOptions: MustacheOptions,
) => {
  if (isValue(translations)) {
    const translatedLabel = translations[key]
    if (isValue(translatedLabel)) {
      return Mustache.render(translatedLabel, mustacheOptions)
    }
  }
  throw new Error(`${key} missing`)
}

export const getBooleanTranslationKey = (value: boolean): string => (value ? 'yes' : 'no')

export const T = (translationKey: string) =>
  createTranslations({
    deviceBrandName: getDeviceBrandName(),
    hardwareName: getHardwareName(),
  })(translationKey)
